import scores from './provider.scores.json'
import { provider } from './provider'

// -------------------------------------
// Provide array of keys for questions
// -------------------------------------
export function questions( { drugs, rules, faqs }, quotes = false ) {

  const data = provider( { drugs, rules, faqs } )

  // Don't start checking yet not to overalert
  if ( data.drugsWith( "qtc" ).length < 2 && data.drugsWith( "known" ).length == 0 ) {
    return []
  }

  const missing = []

  for ( const id in scores ) {
    for ( const faq in scores[ id ] ) {
      if ( quotes && faqs[ id ] && faqs[ id ][ faq ] == "" ) {
        missing.push( `${id}.${faq}` )
      }
      if ( !faqs[ id ] || faqs[ id ][ faq ] == undefined ) {
        missing.push( `${id}.${faq}` )
      }
    }
  }

  return missing
}